// components/Chatbot/Chatbot.tsx
import React from 'react';
import { Box } from '@mui/material';
import ChatbotIcon from './ChatbotIcon';
import ChatbotWindow from './ChatbotWindow';
import { useChatbot } from './useChatbot';

const Chatbot: React.FC = () => {
  const { isOpen, messages, isLoading, options, toggleChat, sendMessage } = useChatbot();

  return (
    <>
      <Box
      // sx={{
      //   position: 'fixed',
      //   bottom: 16,
      //   right: 16,
      //   zIndex: 9999,
      // }}
      >
        {isOpen && (
          <ChatbotWindow
            messages={messages}
            isLoading={isLoading}
            options={options}
            onSendMessage={sendMessage}
            onClose={toggleChat}
          />
        )}
        <ChatbotIcon isOpen={isOpen} onClick={toggleChat} hasNewMessages={false} />
      </Box>
    </>
  );
};

export default Chatbot;
